import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <AppSection />
        <FAQSection />
        <AboutSection />
        <IndexSection />
        <MediaSection />
        <FeaturesSection />
        <RankingSection />
        <CarouselSection />
        <CardsSection />
        <UpdatesSection />
        <ContactSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}